import { NS } from '../constants';

export const SET_MAP_BOUNDS = `${NS}/SET_MAP_BOUNDS`;
